import { render, staticRenderFns } from "./ImageAnnotator.vue?vue&type=template&id=808e23e2&scoped=true"
import script from "./ImageAnnotator.vue?vue&type=script&lang=js"
export * from "./ImageAnnotator.vue?vue&type=script&lang=js"
import style0 from "./ImageAnnotator.vue?vue&type=style&index=0&id=808e23e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808e23e2",
  null
  
)

export default component.exports